export default {
  // Endpoints
  loginEndpoint: '/v1/users/login',
  // loginEndpoint: '/jwt/login',
  // registerEndpoint: '/jwt/register',
  // refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/v1/users/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  // storageRefreshTokenKeyName: 'refreshToken',
}
